import Vue from "vue";

export default Vue.extend({
    template: `
        <span>            
           <button v-on:click="invokeParentMethod">
            <img  style='margin-left:5px;margin-top:2px' width='20px' class="img-icons" src="`+require('@/assets/remove_icon.png')+`"/>
          </button>
        </span>
    `,
    data: function () {
        return {
        };
    },
    beforeMount() {
    },
    mounted() {
    },
    methods: {
        invokeParentMethod() {
            console.log(this.params.context)
            this.params.context.componentParent.methodFromParent(this.params.node.rowIndex)
        }
    }
});